<template>
  <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
    <ts-loading-banner :loading="loading">
      <table class="ts-w-full">
        <thead>
          <tr>
            <th
              class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-left ts-whitespace-no-wrap"
            >
              {{ $t('saleContract.invoiceDate') }}
            </th>
            <th
              class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-left ts-whitespace-no-wrap"
            >
              {{ $t('saleContract.invoiceNo') }}
            </th>
            <th
              class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center ts-whitespace-no-wrap"
            >
              {{ $t('saleContract.uom') }}
            </th>
            <th
              class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-right ts-whitespace-no-wrap"
            >
              {{ $t('saleContract.unitPriceSold') }}
            </th>

            <th
              class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-right ts-whitespace-no-wrap"
            >
              {{ $t('saleContract.uThbSold') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="soldPrice.length == 0">
            <td class="ts-text-red-500 ts-h-10 ts-text-center" colspan="5">
              No Sold Price
            </td>
          </tr>
          <tr
            v-for="(price, index) in soldPrice"
            :key="index"
            class="ts-cursor-pointer hover:ts-bg-gray-300"
            :class="{
              active: current_active == price.stock_out_id
            }"
            @click="selectItem(price)"
          >
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-left">
              {{ price.stock_out_date }}
            </td>
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-left">
              {{ price.invoice_no }}
            </td>
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-center">
              {{ price.uom_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-right">
              {{ $defaultCurrencyWithCode(price.unit_price) }}
            </td>
            <td class="ts-whitespace-no-wrap ts-px-2 ts-py-1 ts-text-right">
              {{ $defaultCurrencyWithCode(price.unit_price * 32, 'THB', 'th-TH') }}
            </td>
          </tr>
        </tbody>
      </table>
    </ts-loading-banner>
  </div>
  <!-- <small
      ><i>{{ $t('saleContract.clickToAddPrice') }}</i></small
    > -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'SoldPrice',
  props: ['value', 'selectedProduct'],
  data () {
    return {
      product: null,
      soldPrice: [],
      model: {},
      loading: false,
      current_active: null
    }
  },
  computed: {
    ...mapState('wholesale/saleContract', ['edit_data', 'formViewData'])
  },
  created () {
    this.model = this.value
    this.product = this.selectedProduct
    this.fetchFormViewModel()
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getFormViewData']),
    async fetchFormViewModel () {
      this.loading = true
      await this.getFormViewData({
        index: 'soldPrice',
        params: {
          fnName: 'soldPrice',
          product_id: this.product.product_id,
          customer_id: this.model.customer_id,
          uom_id: this.product.uom_id
        }
      })
      this.soldPrice = this.formViewData['soldPrice']
      this.loading = false
    },
    selectItem (unit_price) {
      let price = unit_price.unit_price
      this.current_active = unit_price.stock_out_id
      this.model.item_list.find(e => e.product_id == this.product_id)[
        'unit_price'
      ] = parseFloat(price)
      this.$emit('priceChange')
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
.active {
  background: rgba(209, 213, 219);
}
</style>
